<template>
  <section :style="style">
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: "vertical-spacing",
  props: {
    top: { type: Number, defaults: 100 },
    bottom: { type: Number, defaults: 100 },
    backgroundColor: { type: String, defaults: "" }
  },
  computed: {
    style() {
      return {
        ...this.getStyleString(this.top, true),
        ...this.getStyleString(this.bottom),
        backgroundColor: this.backgroundColor
      };
    }
  },

  methods: {
    isZero: int => int === 0,
    isNegative: int => int < 0,
    getStyleString(value, isTop) {
      return this.isZero(value) ? {} : this.paddingOrMargin(value, isTop);
    },
    paddingOrMargin(value, isTop = false) {
      const marginKey = isTop ? "marginTop" : "marginBottom"
      const paddingKey = isTop ? "paddingTop" : "paddingBottom"
      
      return this.isNegative(value)
        ? { [marginKey]: value + "px" }
        : { [paddingKey]: value + "px" };
    }
  }
};
</script>